
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  filters: {
  },
  components: {
  }
})
export default class SnackbarMessage extends Vue {
  @Prop({ required: true })
  private show!: boolean

  @Prop({ required: true })
  private message!: string

  @Prop({ required: true })
  private color!: string

  @Watch('show')
  disableToastTimer () {
    if (this.show) {
      setTimeout(() => {
        this.$emit('disable')
      }, 5000)
    }
  }
}
